
import { Mixins, Component } from 'vue-mixin-decorator';
import { namespace } from 'vuex-class';

import FieldMixin from '@/mixins/create/field';
import { Dictionary, Dictionaries } from '@/services/dictionaries-service';

const commonStore = namespace('common');

@Component
export default class StepExteriorColor extends Mixins<FieldMixin>(FieldMixin) {
  @commonStore.State dictionaries!: Dictionaries;

  private get specs() {
    return this.data.specs || {};
  }

  private get color() {
    return this.specs.color;
  }

  private set color(color) {
    this.clearError({ name: 'specs.color' });
    this.setField({ specs: { ...this.specs, color } });
  }

  private get error() {
    return (this.errors['specs.color'] || []).join('. ');
  }
}
